import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { TohumUiModule, TohumUiInitService, TohumUiRoutingModule } from '@anadolu-commons/tohum-ui';
import { BrowserModule } from '@angular/platform-browser';
import { EditorModule, TINYMCE_SCRIPT_SRC  } from '@tinymce/tinymce-angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AnaSayfaComponent } from './ana-sayfa/ana-sayfa.component';
import { SharedModule } from './shared/shared.module';
import { WelcomeComponent } from './welcome/welcome.component';
import { YetkisizKullaniciComponent } from './yetkisiz-kullanici/yetkisiz-kullanici.component';

// export function initApp(initService: TohumUiInitService) {
//     return () => initService.init();
// }

@NgModule({
    declarations: [
        AppComponent,
        AnaSayfaComponent,
        WelcomeComponent,
        YetkisizKullaniciComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        EditorModule,
        SharedModule,
        TohumUiRoutingModule,
        TohumUiModule.forRoot({
            menuConfig: {
                list: [
                    {
                        name: 'İç Değerlendirme Raporları', slug: 'kurum-ic-degerlendirme', iconClass: 'fa fa-university', permissions: ['IcDegerlendirmeGoruntuleme'],
                        children:[
                            {name: 'Birim İç Değerlendirme Raporu', slug: 'birim-ic-deger-rapor', page:true, iconClass: 'fas fa-file-chart-line', permissions: ['BidrDegerlendirmeGoruntuleme']},
                            {name: 'Kurum İç Değerlendirme Raporu', slug: 'kurum-ic-deger-rapor', page:true, iconClass: 'fas fa-file-chart-pie', permissions: ['UniversiteIciDegerlendirmeGoruntuleme']},
                            {name: 'KİDR Ekip Raporları', slug: 'ekip-rapor', page:true, iconClass: 'fas fa-file-contract', permissions: ['EkipRaporGoruntuleme']},
                            {name: 'Birim Kanıtları', slug: 'birim-kanit', iconClass : 'fas fa-file-search', permissions: ['AltBirimKanitGoruntuleme']}
                        ]
                    },
                    {
                        name: 'Kullanıcı Yönetimi', slug: 'kullanici-yonetim', iconClass: 'fa fa-user-cog', permissions: ['KullaniciYonetimiGoruntuleme'],
                        children:[
                            {name: 'Birimler', slug: '', page:true, iconClass: 'fa fa-university', permissions: ['KullaniciYonetimiGoruntuleme']},
                            {name: 'Kullanıcılar', slug: 'kullanici', page:true, iconClass: 'fa fa-user', permissions: ['KullaniciYonetimiGoruntuleme']},
                            {name: 'Roller', slug: 'rol', page:true, iconClass: 'fad fa-layer-group', permissions: ['KullaniciYonetimiGoruntuleme']},
                            {name: 'Yetkiler', slug: 'yetki', page:true, iconClass: 'fas fa-lock-alt', permissions: ['KullaniciYonetimiGoruntuleme']},
                            {name: 'Rol Yetki', slug: 'rol-yetki', page:true, iconClass: 'fas fa-unlock-alt', permissions: ['KullaniciYonetimiGoruntuleme']},                           
                            {name: 'Kullanıcı Rol Birim', slug: 'kullanici-rol-birim', page:true, iconClass: 'fa fa-user-lock', permissions: ['KullaniciYonetimiGoruntuleme']}                                                            
                        ]
                    }
                ]
            }
        })
    ],
    providers: [{ provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' }
        // { provide: APP_INITIALIZER, useFactory: initApp, deps: [TohumUiInitService], multi: true }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
